import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Submission         from 'app/components/forms/submission';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';
import FormsDuck          from 'app/ducks/forms';
import RoutingSlx from 'app/selectors/routing';


class PageFormSubmissionShow extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {form, submission} = this.props;

    return (
      <MainLayout className="page-formsub-edit">
        <Meta title="Form Submission | Millie" />
        <div className="widther">
          <h1>Form Submission</h1>
          {!!(form && submission) && (
            <Submission form={form} submission={submission} />
          )}
        </div>
      </MainLayout>
    );
  }

}

const stateToProps = (state) => {
  const subId = RoutingSlx.params(state).formSubmissionId;
  const [submission, form] = FormsDuck.Slx.getSubAndForm(state)(subId);
  return {
    submission,
    form,
  };
};
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageFormSubmissionShow);
